import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import type { OneTimeTokenJwt, CustomerAccountJwt } from "breuer-supercharged-sdk"
import { invalidateAccount } from "../hooks/useAccount";

export type User = OneTimeTokenJwt | CustomerAccountJwt;

interface AuthCredentials {
    accessToken: string;
    refreshToken?: string;
}

interface UserState {
    user: User | null;
    credentials: AuthCredentials | null;
    isLoading: boolean;
    setUser: (user: User | null) => void;
    setCredentials: (credentials: AuthCredentials | null) => void;
    setLoading: (loading: boolean) => void;
    clearAuth: () => void;
}

export const useUserStore = create<UserState>()(
    persist(
        (set) => ({
            user: null,
            credentials: null,
            isLoading: true,
            setUser: (user) => set({ user }),
            setCredentials: (credentials) => set({ credentials }),
            setLoading: (isLoading) => set({ isLoading }),
            clearAuth: () => {
                set({ user: null, credentials: null, isLoading: false });
                invalidateAccount();
            },
        }),
        {
            name: 'customer-auth-storage',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                credentials: state.credentials,
                user: state.user
            }),
        }
    )
);
